package org.braunequip.web.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.css.functions.toImage
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val freightBrokeringBg = CssStyle {
    base {
        Modifier
            .background(
                Background.of(
                    image = BackgroundImage.of(url("empiregroup.jpg")),
                    repeat = BackgroundRepeat.NoRepeat,
                    position = BackgroundPosition.of(CSSPosition.TopRight),
                    size = BackgroundSize.Contain,
                ),
                Background.of(image = linearGradient(Color.rgba(255, 255, 255, 0.5f), Color.rgba(255, 255, 255, 0.5f)).toImage())
            )
    }
}

val SplitHeroColumn = CssStyle {
    base {
        Modifier
            .width(100.percent)

    }
    Breakpoint.MD {
        Modifier
    }
}

val smallPDFBoxStyle = CssStyle {
    base {
        Modifier
            .width(350.px)
            .margin(topBottom = 0.px, leftRight = autoLength)
    }
}

val smallListStyle = CssStyle {
    base {
        Modifier
            .width(400.px)
            .margin(topBottom = 0.px, leftRight = autoLength)
    }
}